import { lazy } from 'react';
import Loadable from 'components/Loadable';

const AuthLogout = Loadable(lazy(() => import('pages/auth/logout')));

const LogoutRoutes = {
      path: '/logout',
      element: <AuthLogout />,
};

export default LogoutRoutes;
